// Centralized pool of default genie images and helpers for selection.
//
// Migrated to the new /genie-mascots/ library. The legacy 13-image numbered
// pool at /genie-images/ has been retired; consumers calling the seeded /
// random selectors below now receive new mascot art automatically.

import { BRAND_MASCOT_CONCIERGE, BRAND_MASCOT_POOL } from "./brandMascots";

// Curated pool of 13 role mascots (excludes the concierge "group" image).
export const GENIE_AVATAR_IMAGES: string[] = [...BRAND_MASCOT_POOL];

// Full pool including the concierge composition.
export const GENIE_DEFAULT_IMAGE_URLS: string[] = [
  ...GENIE_AVATAR_IMAGES,
  BRAND_MASCOT_CONCIERGE,
];

export function getRandomGenieDefaultImage(): string {
  const pool = GENIE_AVATAR_IMAGES;
  const index = Math.floor(Math.random() * pool.length);
  return pool[index];
}

export function getSeededGenieDefaultImage(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % GENIE_AVATAR_IMAGES.length;
  return GENIE_AVATAR_IMAGES[index];
}

/**
 * Get all available genie avatar images for selection
 */
export function getAllGenieAvatars(): string[] {
  return [...GENIE_AVATAR_IMAGES];
}
